var app = angular.module('leonardo');

var PropertyGroupService = function(BaseRestService) {
  var service = new BaseRestService('groups');

  service.getGroups = function (groups_Ids) {
    var properties = [];
    return service.getlist({
        id: groups_Ids ? groups_Ids.join(",") : null
      }).then(function (list) {
        angular.forEach(list, function (group) {
          if (group.properties.length > 0) {
            angular.forEach(group.properties, function (data) {
              properties.push(data.id);
            });
          }
        });
        return (properties.find(function (element, index) {
          return properties.indexOf(element) != index;
        }));
      });
  };

  return service;
};

app.factory('PropertyGroupService', ['BaseRestService', PropertyGroupService]);
